<template>
  <div class="shop-apply-wrap">
      <div class="title-box">
        <p>请填写以下信息，提交后我们将尽快与您联系</p>
      </div>

      <el-form
        ref="applyFormRef"
        :model="applyForm"
        :rules="applyRules"
        label-width="120px"
        class="apply-form"
        size="small"
      >
        <el-form-item label="申请人姓名" prop="truename">
          <el-input v-model="applyForm.truename" placeholder="请输入申请人姓名"></el-input>
        </el-form-item>

        <el-form-item label="申请人手机号" prop="mobile">
          <el-input v-model="applyForm.mobile" placeholder="请输入申请人手机号"></el-input>
        </el-form-item>

        <el-form-item label="验证码" prop="sms_code">
          <div class="code-row">
            <el-input v-model="applyForm.sms_code" placeholder="请输入验证码"></el-input>
            <el-button :disabled="codeDisabled" @click="getCode">{{ btnText }}</el-button>
          </div>
        </el-form-item>

        <el-form-item label="申请门店名称" prop="title">
          <el-input v-model="applyForm.title" placeholder="请输入申请门店名称"></el-input>
        </el-form-item>

        <el-form-item label="申请门店电话" prop="tel">
          <el-input v-model="applyForm.tel" placeholder="请输入申请门店电话"></el-input>
        </el-form-item>
        <el-form-item label="省市区" prop="district"  >
        <select-city class=""
            :release="true"
            :width="60"
            :order="true"
            @getCityInfo="getCityInfo"
            :provinceId="applyForm.province"
            :cityId="applyForm.city"
            :districtIds="applyForm.district"/>
        </el-form-item>
        <el-form-item label="详细地址" prop="address">
          <el-input v-model="applyForm.address" placeholder="请输入详细地址"></el-input>
        </el-form-item>

        <el-form-item label="门店类型" prop="type">
          <el-select v-model="applyForm.type" placeholder="请选择门店类型">
            <el-option label="采购商" value="2"></el-option>
            <el-option label="酒店" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="submit-btn mb-4" @click="handleSubmit">提交申请</el-button>
        </el-form-item>
      </el-form>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  name: "ShopApply",
  data() {
    return {
      codeDisabled: false,
      timer: null,
      btnText: "获取验证码",
      applyForm: {
        truename: "",        //申请人姓名
        mobile: "",          //申请人手机号
        sms_code: "",        //验证码
        title: "",           //申请门店名称
        tel: "",             //申请门店电话
        province: "",        //省
        city: "",            //市
        district: [],   //区县编码
        address: "",         //详细地址
        type: ""         //门店类型
      },
      mobileverify:[],     //已发送验证码手机号
      applyRules: {
        truename: [{ required: true, message: "请输入申请人姓名", trigger: "blur" }],
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { pattern: /^1[3-9]\d{9}$/, message: "手机号格式不正确", trigger: "blur" }
        ],
        sms_code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        title: [{ required: true, message: "请输入申请门店名称", trigger: "blur" }],
        tel: [{ required: true, message: "请输入门店电话", trigger: "blur" }],
        province: [{ required: true, message: "请选择省份", trigger: "change" }],
        city: [{ required: true, message: "请选择城市", trigger: "change" }],
        district_code: [{ required: true, message: "请选择区县", trigger: "change" }],
        address: [{ required: true, message: "请输入详细地址", trigger: "blur" }],
        shopType: [{ required: true, message: "请选择门店类型", trigger: "change" }]
      }
    };
  },
  watch:{
    'applyForm.mobile':{
      handler(newVal){
        this.isSendCode(newVal);
      }
    }
  },
  methods: {
    getCode:_.debounce(async function(newVal) {
      if (this.codeDisabled) return;
      if (!this.applyForm.mobile) {
        this.$message.warning("请先填写手机号");
        return;
      }
      const reg = /^1[3-9]\d{9}$/
      if (!reg.test(this.applyForm.mobile)) {
        this.$message.warning("手机号格式不正确");
        return
      }
        let resData = await this.$axios.post(this.url, {mobile:this.applyForm.mobile})
        if (resData.code === '00000') {
            this.countdown(60);
            this.$message({message: '验证码发送成功',duration:1000})
            //保存已发送验证码手机号刷新再次发送情况
            const index = this.mobileverify.findIndex(user => user.mobile === this.applyForm.mobile);
            if (index !== -1) {
                this.mobileverify[index]={mobile:this.applyForm.mobile,tiem:new Date().getTime()};
            }else{
                this.mobileverify.push({mobile:this.applyForm.mobile,tiem:new Date().getTime()});
            }
            sessionStorage.setItem('mobileverify',JSON.stringify(this.mobileverify));
        }
    },1000),
    //判断是否已经发送了验证码
    isSendCode(phoneNumber) {
        console.log(phoneNumber)
        let mobileverify =JSON.parse(sessionStorage.getItem('mobileverify'))||[];
        let tiem=mobileverify.filter(todo=>todo.mobile==phoneNumber)[0];
        let nowTime=new Date().getTime();
        if(tiem&&(nowTime-tiem.tiem)<60000){
          let num =60-(nowTime-tiem.tiem)/1000;
            this.countdown(num.toFixed(0));
        }
        this.mobileverify=mobileverify;
    },
    //倒计时
    countdown(count){
      this.codeDisabled = true;
      this.btnText = `${count}s后重新获取`;
      this.timer = setInterval(() => {
        count--;
        this.btnText = `${count}s后重新获取`;
        if (count <= 0) {
          clearInterval(this.timer);
          this.codeDisabled = false;
          this.btnText = "获取验证码";
        }
      }, 1000);
    },
    provinceChange() {
      this.applyForm.city = "";
      this.applyForm.district_code = "";
    },
    cityChange() {
      this.applyForm.district_code = "";
    },
    handleSubmit() {
      this.$refs.applyFormRef.validate(async valid => {
        if (!valid) return;
        // 提交参数直接对应后端字段
        const params = {
          truename: this.applyForm.truename,
          mobile: this.applyForm.mobile,
          sms_code: this.applyForm.sms_code,
          title: this.applyForm.title,
          tel: this.applyForm.tel,
          province: this.applyForm.province,
          city: this.applyForm.city,
          district: this.applyForm.district_code, //后端字段district映射区县编码
          address: this.applyForm.address,
          shopType: this.applyForm.shopType
        };
        console.log("提交参数", params);
        /*
        const res = await this.$axios.post('/api/xxx', params)
        if(res.code === 0){
          this.$message.success('提交成功')
          this.$refs.applyFormRef.resetFields()
        }
        */
      });
    },
    //获取省市区id
    getCityInfo (info) {
    console.log(info)
    this.formData.province = info.province;
    this.formData.city = info.city;
    this.formData.district = info.district.map(v => v.id);
    // this.cityName = info;
    },
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  }
};
</script>

<style scoped>
.shop-apply-wrap{
    width: 80%;
    margin: 20px auto;
}
.apply-card {
  max-width: 1000px;
  margin: 0 auto;
}
.title-box h2 {
  margin: 0;
  font-size: 24px;
}
.title-box p {
  color: #888;
  margin: 6px 0 24px;
}
.code-row {
  display: flex;
  gap:12px;
}
.code-row >>> .el-input {
  flex: 1;
}
.area-row {
  display: flex;
  gap:12px;
}
.area-row >>> .el-select {
  flex: 1;
}
.submit-btn {
  width: 320px;
  height: 44px;
  font-size:16px;
}
.apply-form >>> .el-form-item__label:before {
  content: "*";
  color: #f56c6c;
  margin-right:4px;
}
</style>

<style>
    .shop-apply-wrap .el-select{
        width: 100%;
    }
</style>
